import { render } from "./AddOrganization.vue?vue&type=template&id=78747e3a&ts=true"
import script from "./AddOrganization.vue?vue&type=script&lang=ts"
export * from "./AddOrganization.vue?vue&type=script&lang=ts"

import "./Organization.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__